import { Navigate, Outlet, RouteObject } from "react-router-dom";
import Protected from "@/pages/protected";
import TaskRoute from "./task";
import ContactRoute from "./contact";
import OfficeRoute from "./office";
import PicklistRoute from "./picklist";
import RegistrationRoute from "./registration";

const MedRepRoute: RouteObject = {
    path: "dm",
    element: (
        <Protected groups={["app_medrep_admin", "team_medrep"]}>
            <Outlet />
        </Protected>
    ),
    children: [{ index: true, element: <Navigate to="/dm/contacts" replace /> }, ContactRoute, OfficeRoute, TaskRoute, PicklistRoute, RegistrationRoute]
};

export default MedRepRoute;
